var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeeth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21125 0.405609C2.86116 0.144574 2.43188 0.00200797 1.9901 0.00200797C0.889815 0.00200797 0 0.85941 0 1.91962V2.04411C0 2.36137 0.0771034 2.6726 0.222975 2.95773L0.712686 3.90349C0.80646 4.0822 0.87106 4.27295 0.90857 4.46973L1.67335 8.60213C1.71503 8.82702 1.91508 8.99167 2.15056 8.9997C2.38604 9.00774 2.59651 8.85112 2.65069 8.63024L3.25293 6.19458C3.33837 5.85925 3.64678 5.62431 4.00104 5.62431C4.3553 5.62431 4.66371 5.85925 4.74707 6.19257L5.34931 8.62823C5.40349 8.85112 5.61396 9.00573 5.84944 8.9977C6.08492 8.98967 6.28497 8.82501 6.32665 8.60012L7.09143 4.46772C7.12894 4.27094 7.19354 4.08019 7.28731 3.90148L7.77703 2.95573C7.92498 2.6726 8 2.35936 8 2.0421V1.99993C8 0.895553 7.07059 0 5.92446 0C5.42224 0 4.9367 0.176701 4.55744 0.49396L4.49075 0.550183C4.30466 0.682603 3.78822 0.839077 3.21125 0.405609Z",
    fill: "#8193A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth);
export default __webpack_public_path__ + "static/media/teeth.aaded9ac3453d55f8feb8772c76c5e49.svg";
export { ForwardRef as ReactComponent };